/* EZ Trim manufacturer chat. Loaded only on EZTRIM product pages by
   snippets/tl-ezchat.liquid. Crisp (EZ Trim's account) loads on the first tap,
   never on page load. One chat window at a time: tapping closes Gorgias, and
   opening Gorgias closes this. Each message is copied to n8n, which mirrors the
   chat into a closed Gorgias ticket tagged "EZ Trim". Message text never goes
   to Google Analytics. Plan: .claude/plans/2026-10-14-eztrim-chat.md */
(function () {
  'use strict';
  var cfg = window.TL_EZCHAT;
  if (!cfg || !cfg.websiteId || !cfg.logUrl) return;

  var FAIL_TEXT = 'Chat could not load. Use Live chat or call (360) 800-5535.';
  var REPLY_TEXT = 'New reply from EZ Trim. Tap to read.';
  var crispReady = false;
  var scriptAdded = false;
  var waiters = [];
  var openedAt = 0;
  var sessionId = '';
  var gorgiasTimer = null;
  var firstSentAt = 0;
  var replied = false;

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics is optional */ }
  }

  function log(event, extra) {
    if (!sessionId) return;
    var body = { v: 1, store: 'trimleaf.com', session_id: sessionId, event: event, at: new Date().toISOString(), page_path: location.pathname, product: cfg.product };
    for (var k in extra) body[k] = extra[k];
    try {
      fetch(cfg.logUrl, { method: 'POST', body: JSON.stringify(body), keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) { /* logging must never break the chat */ }
  }

  function setStatus(text) {
    var els = document.querySelectorAll('[data-ez-status]');
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }

  function messageFields(m) {
    var content = typeof m.content === 'string' ? m.content : JSON.stringify(m.content || '');
    return {
      from: m.from === 'operator' ? 'operator' : 'user',
      type: String(m.type || ''),
      content: content.slice(0, 4000),
      nickname: m.user && m.user.nickname ? String(m.user.nickname).slice(0, 80) : '',
      fingerprint: m.fingerprint || null,
      timestamp: m.timestamp || Date.now(),
      origin: String(m.origin || '')
    };
  }

  function onSent(m) {
    if (!m) return;
    log('message', { message: messageFields(m) });
    if (!firstSentAt) {
      firstSentAt = m.timestamp || Date.now();
      track('ez_chat_message', { product: cfg.product.title });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'EZ Trim chat': sessionId } }) }).catch(function () {});
    }
  }

  function onReceived(m) {
    if (!m) return;
    log('message', { message: messageFields(m) });
    // Crisp is hidden while closed, so a late reply would go unseen.
    try { if (m.from === 'operator' && !window.$crisp.is('chat:opened')) setStatus(REPLY_TEXT); } catch (e) { /* ignore */ }
    if (m.from === 'operator' && firstSentAt && !replied) {
      replied = true;
      track('ez_chat_reply', { product: cfg.product.title, seconds: Math.max(0, Math.round(((m.timestamp || Date.now()) - firstSentAt) / 1000)) });
    }
  }

  // window.tlChatWidgets comes from custom-script.js (the Ask dock module).
  function otherChatOpen() {
    var w = window.tlChatWidgets;
    if (w) return w.anyOtherOpen();
    return !!(window.GorgiasChat && GorgiasChat.isOpen && GorgiasChat.isOpen());
  }

  function closeOtherChats() {
    try {
      var w = window.tlChatWidgets;
      if (w) w.closeOthers();
      else if (window.GorgiasChat && GorgiasChat.isOpen && GorgiasChat.isOpen()) GorgiasChat.close();
    } catch (e) { /* ignore */ }
  }

  // Started on the first tap and left running: Crisp's open/close events can
  // arrive out of order on a restored session, so this checks real state.
  // The grace period lets the other chats finish their close fade.
  function watchOthers() {
    if (gorgiasTimer !== null) return;
    gorgiasTimer = window.setInterval(function () {
      try {
        var c = window.$crisp;
        if (Date.now() - openedAt < 1500) return;
        if (c && typeof c.is === 'function' && c.is('chat:opened') && otherChatOpen()) {
          c.push(['do', 'chat:close']);
        }
      } catch (e) { /* keep checking */ }
    }, 500);
  }

  function settle(ok) {
    var list = waiters;
    waiters = [];
    for (var i = 0; i < list.length; i++) list[i](ok);
  }

  // The script is added once. A tap that times out shows the fallback, but
  // Crisp may still arrive late; the next tap then uses it.
  function load() {
    return new Promise(function (resolve, reject) {
      if (crispReady) { resolve(); return; }
      var done = false;
      var timer = window.setTimeout(function () { finish(false); }, 15000);
      function finish(ok) {
        if (done) return;
        done = true;
        window.clearTimeout(timer);
        if (ok) resolve(); else reject();
      }
      waiters.push(finish);
      if (scriptAdded) return;
      scriptAdded = true;
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = cfg.websiteId;
      // Crisp picks full screen only below 600px tall or 480px wide. On a
      // 555px-wide phone it opened as the floating desktop box, the keyboard
      // (resizes-content) flipped it to full screen, and closing the keyboard
      // flipped it back. Locking full view on phone layouts also stops Crisp
      // focusing the message box, so the keyboard no longer opens by itself.
      if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
        window.CRISP_RUNTIME_CONFIG = { lock_full_view: true };
      }
      // Crisp keeps one handler per event; register each exactly once here.
      window.$crisp.push(['do', 'chat:hide']);
      window.$crisp.push(['on', 'session:loaded', function (id) { sessionId = String(id || ''); }]);
      window.$crisp.push(['on', 'chat:closed', function () { window.$crisp.push(['do', 'chat:hide']); }]);
      window.$crisp.push(['on', 'message:sent', onSent]);
      window.$crisp.push(['on', 'message:received', onReceived]);
      window.$crisp.push(['on', 'user:email:changed', function (email) { log('email', { email: String(email || '').slice(0, 200) }); }]);
      window.CRISP_READY_TRIGGER = function () {
        if (crispReady) return;
        crispReady = true;
        if (!sessionId) sessionId = String(window.$crisp.get('session:identifier') || '');
        settle(true);
        // Arrived after the 15s fallback: open it if the shopper is still waiting.
        if (lateOpen) { var f = lateOpen; lateOpen = null; f(); }
      };
      var s = document.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = true;
      s.onerror = function () { scriptAdded = false; settle(false); };
      document.head.appendChild(s);
    });
  }

  // The first tap downloads Crisp (~1.5s). A plain window in Crisp's spot
  // opens at once so the tap feels as quick as Live chat; Crisp replaces it.
  var shell = null;
  var shellWanted = false;
  var lateOpen = null;

  function showShell() {
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'tl-ezshell';
      shell.setAttribute('role', 'dialog');
      shell.setAttribute('aria-label', 'EZ Trim chat');
      shell.innerHTML = '<div class="tl-ezshell__head"><img class="tl-ezmark" src="' + cfg.markUrl + '" width="36" height="36" alt=""><b>EZ Trim</b>' +
        '<button type="button" class="tl-ezshell__close" aria-label="Close">&times;</button></div>' +
        '<div class="tl-ezshell__body"><span class="tl-ezshell__spin" aria-hidden="true"></span><p data-ez-shell-text role="status"></p></div>';
      shell.querySelector('.tl-ezshell__close').addEventListener('click', function () { shellWanted = false; hideShell(); });
      document.body.appendChild(shell);
    }
    shell.classList.remove('tl-ezshell--failed');
    shell.querySelector('[data-ez-shell-text]').textContent = 'Connecting to EZ Trim\u2026';
    shell.hidden = false;
    shellWanted = true;
  }

  function hideShell() { if (shell) shell.hidden = true; }

  // Keep the shell up until Crisp's own window is showing, so nothing flashes.
  function hideShellWhenOpen() {
    var tries = 0;
    (function check() {
      var c = window.$crisp;
      if (++tries > 60 || (c && typeof c.is === 'function' && c.is('chat:opened'))) { hideShell(); return; }
      window.setTimeout(check, 50);
    })();
  }

  function openChat(btn) {
    var placement = btn.getAttribute('data-ez-placement') || 'unknown';
    track('ez_chat_tap', { product: cfg.product.title, placement: placement });
    setStatus('');
    closeOtherChats();
    var viaShell = !crispReady;
    if (viaShell) showShell(); else hideShell();
    lateOpen = null;
    btn.setAttribute('aria-busy', 'true');
    function show() {
      // Closed the shell, or opened another chat, while Crisp loaded: stay closed.
      if (viaShell && (!shellWanted || otherChatOpen())) { hideShell(); return; }
      setStatus('');
      var $c = window.$crisp;
      $c.push(['set', 'session:data', [[['dealer', 'Trimleaf'], ['product', cfg.product.title], ['sku', cfg.product.sku || ''], ['source_placement', placement]]]]);
      if (!$c.get('message:text')) $c.push(['set', 'message:text', ['Question about ' + cfg.product.title + ': ']]);
      openedAt = Date.now();
      $c.push(['do', 'chat:show']);
      $c.push(['do', 'chat:open']);
      watchOthers();
      if (viaShell) hideShellWhenOpen();
    }
    load().then(show, function () {
      setStatus(FAIL_TEXT);
      if (viaShell && shellWanted && shell) {
        shell.classList.add('tl-ezshell--failed');
        shell.querySelector('[data-ez-shell-text]').textContent = FAIL_TEXT;
        lateOpen = function () { if (shellWanted && shell && !shell.hidden) show(); };
      }
    }).then(function () { btn.removeAttribute('aria-busy'); });
  }

  // A page left open across 9pm MT loses the entry points; across 7am they come
  // back. An open chat stays open. tlEzInHours comes from snippets/tl-ezchat.liquid.
  window.setInterval(function () {
    if (typeof window.tlEzInHours !== 'function') return;
    var show = window.tlEzInHours();
    var els = document.querySelectorAll('.tl-ezcard, .tl-buybox__help-btn--ez');
    for (var i = 0; i < els.length; i++) els[i].hidden = !show;
  }, 60000);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ez-open]');
    if (!btn) return;
    e.preventDefault();
    openChat(btn);
  });
})();
